import "core-js/modules/es.array.concat.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
import _imports_0 from '@/assets/images/right_arrow_gray.svg';
var _hoisted_1 = {
  class: "account-features"
};
var _hoisted_2 = {
  class: "account-features-title"
};
var _hoisted_3 = {
  class: "account-features-list"
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "left"
};
var _hoisted_6 = {
  class: "item-title"
};
import ProfilePopup from "@/components/me/ProfilePopup.vue";
import PontHistoryPoupup from "@/components/points/PontHistoryPoupup.vue";
import InvoiceRecordPopup from "@/components/invoice/InvoiceRecordPopup.vue";
import SvgIcon from "@/components/base/SvgIcon.vue";
import { ref } from "vue";
import { useSupplierStore } from "@/store/supplierStore";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import ActionSheet from "../dialog/src/ActionSheet.vue";
import { LangSettingEnum } from "@/constant/lang";
import { Persistent } from "@/utils/cache/persistent";
import { LOCAL_KEY_LANG_SETTING } from "@/constant/storageKey";
import { getCurrentLocaleValue } from "@/lang";
export default {
  __name: 'AccountFeature',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var supplierStore = useSupplierStore();
    var showProfile = ref(false);
    var showPointHistory = ref(false);
    var showMyInvoice = ref(false);
    var isLangActionSheetVisible = ref(false);
    var featureList = computed(function () {
      return [{
        icon: "point",
        title: t("pointsHistory"),
        handler: function handler() {
          return showPointHistory.value = true;
        },
        show: true
      }, {
        icon: "profile",
        title: t("myProfile"),
        handler: function handler() {
          return showProfile.value = true;
        },
        show: true
      }, {
        icon: "invoice",
        title: t("myEInvoice"),
        handler: function handler() {
          return showMyInvoice.value = true;
        },
        show: supplierStore.getInvoiceSelfServiceOne()
      }, {
        icon: "phone",
        title: t("liveChat"),
        handler: toLiveChat,
        show: supplierStore.getWhatsappid
      }, {
        icon: "lang",
        title: t("language"),
        handler: handleShowLangActionSheet,
        show: true
      }];
    });
    function toLiveChat() {
      window.open("https://wa.me/".concat(supplierStore.getWhatsappid, "/?text=").concat(encodeURIComponent(t("liveChat"))), "_blank");
    }
    var lang = ref(LangSettingEnum.EN);
    var langOptions = [{
      label: "English",
      value: LangSettingEnum.EN
    }, {
      label: "עִבְרִית",
      value: LangSettingEnum.HE
    }, {
      label: "Deutsch",
      value: LangSettingEnum.DE
    }, {
      label: "Français",
      value: LangSettingEnum.FR
    }, {
      label: "Italiano",
      value: LangSettingEnum.IT
    }, {
      label: "中文",
      value: LangSettingEnum.ZH
    }];
    function handleShowLangActionSheet() {
      var _getCurrentLocaleValu;
      lang.value = ((_getCurrentLocaleValu = getCurrentLocaleValue()) === null || _getCurrentLocaleValu === void 0 || (_getCurrentLocaleValu = _getCurrentLocaleValu.split("-")) === null || _getCurrentLocaleValu === void 0 ? void 0 : _getCurrentLocaleValu[0]) || LangSettingEnum.EN;
      isLangActionSheetVisible.value = true;
    }
    function handleSelectLang(lang) {
      Persistent.setLocal(LOCAL_KEY_LANG_SETTING, lang);
      isLangActionSheetVisible.value = false;
      setTimeout(function () {
        window.location.reload();
      }, 300);
    }
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("features")), 1), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(featureList.value, function (item, i) {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: i,
          class: "account-features-item van-haptics-feedback",
          onClick: function onClick($event) {
            var _item$handler;
            return (_item$handler = item.handler) === null || _item$handler === void 0 ? void 0 : _item$handler.call(item);
          }
        }, [_createElementVNode("div", _hoisted_5, [_createVNode(SvgIcon, {
          name: item.icon,
          size: 28,
          class: "item-img"
        }, null, 8, ["name"]), _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)]), _cache[4] || (_cache[4] = _createElementVNode("img", {
          class: "icon",
          src: _imports_0,
          alt: ""
        }, null, -1))], 8, _hoisted_4)), [[_vShow, item.show]]);
      }), 128))]), _createVNode(ProfilePopup, {
        show: showProfile.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return showProfile.value = $event;
        })
      }, null, 8, ["show"]), _createVNode(PontHistoryPoupup, {
        show: showPointHistory.value,
        "onUpdate:show": _cache[1] || (_cache[1] = function ($event) {
          return showPointHistory.value = $event;
        })
      }, null, 8, ["show"]), _createVNode(InvoiceRecordPopup, {
        show: showMyInvoice.value,
        "onUpdate:show": _cache[2] || (_cache[2] = function ($event) {
          return showMyInvoice.value = $event;
        })
      }, null, 8, ["show"]), _createVNode(ActionSheet, {
        visible: isLangActionSheetVisible.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return isLangActionSheetVisible.value = $event;
        }),
        title: _ctx.$t('language'),
        options: langOptions,
        value: lang.value,
        "on-ok": handleSelectLang
      }, null, 8, ["visible", "title", "value"])]);
    };
  }
};